//#region import

import $ from "jquery"; // , { data }
import ToothNumberControls from "./ToothNumberControls.vue";
import ToothNumberButtons from "./ToothNumberButtons.vue";
import ToothNumberDialog from "./ToothNumberDialog.vue";
import {
  updateRaycaster,
  intersectTooth,
  setHighlightedToothColor,
} from "@/components/intersection";
import { updateToothNumbers } from "@/components/saveLoadData";
import { loadFont } from "@/components/draw/draw.js";
import { globalPlanes, empty } from "@/components/reports/ClipDialog.vue";
import { updateDisplayNumberAndName } from "@/components/tooth/teethNaming.js";
import {
  updateToothDentition,
  getToothFileName,
} from "@/components/appStart/adjustModel.js";
import { showToothNumberDialog } from "./ToothNumberDialog.vue";
//#endregion

//#region Fields
let lastTicks = Date.now();
let controlsInitialized = false;
let numberFont = null;
let dy = 3;
let dz = 3;
let maxBox = null;
let maxCenter = null;
let mandBox = null;
let mandCenter = null;
let numbersVisible = false;
//#endregion

var ToothNumberMode = {
  isWhite: true,
  whiteColor: "#ffffff",
  blueColor: "#007bff",
  changedFiles: [],
  isActive: false,
  isOldNumbers: false,
  selectedTooth: {
    number: 0,
    savedNumber: 0,
    newNumber: 0,
    newNumberType: "primary",
    newRemarks: "",
  },
  changingTooth: null,
  changingAnnotation: null,
  setChangingTooth: function (tooth) {
    this.changingTooth = tooth;
    // if (!tooth.savedNumber) {
    // 	tooth.savedNumber = tooth.number;
    // }
    if (!tooth.newNumber) {
      tooth.newNumber = tooth.savedNumber;
    }
    if (!tooth.newNumberType) {
      tooth.newNumberType = tooth.numberType ? tooth.numberType : "primary";
    }
    if (!tooth.newRemarks) {
      tooth.newRemarks = tooth.remarks ? tooth.remarks : "";
    }
    this.selectedTooth.number = tooth.number;
    this.selectedTooth.savedNumber = tooth.savedNumber;
    this.selectedTooth.newNumber = tooth.newNumber;
    this.selectedTooth.newNumberType = tooth.newNumberType;
    this.selectedTooth.newRemarks = tooth.newRemarks;
  },
  resetSelectedTooth: function () {
    this.selectedTooth.number = 0;
    this.selectedTooth.savedNumber = 0;
    this.selectedTooth.newNumber = 0;
    this.selectedTooth.newNumberType = "primary";
    this.selectedTooth.newRemarks = "";
  },
  enterMode: function () {
    enterToothNumberMode();
  },
  leaveMode: function (saveActiveMode) {
    leaveToothNumberMode(false, saveActiveMode);
  },
  mouseMove: function (event) {
    return true;
  },
  mouseUp: function (event) {
    return true;
  },
  mouseClick: function (event) {
    if (this.isOldNumbers) return;
    updateRaycaster(event);
    var tooth = intersectTooth();
    if (tooth) {
      // this.setChangingTooth(tooth);
      showToothNumberDialog(tooth);
    }
  },
};

async function showOldToothNumbers() {
  enterToothNumberMode(true);
}

async function enterToothNumberMode(isOldNumbers) {
  ToothNumberMode.isWhite = vueApp.isWhite;
  ToothNumberMode.whiteColor = vueApp.whiteColor;
  ToothNumberMode.blueColor = vueApp.blueColor;

  initToothNumberControls();
  vueApp.leaveModes(false, true);

  viewer.renderer.clippingPlanes = empty;

  $(".tooth-number-mode-item").css("display", "block");
  if (isOldNumbers) {
    $("#toothNumberSave").css("display", "none");
    $("#toothNumberControls").css("display", "none");
  } else {
    $("#toothNumberSave").css("display", "inline-block");
  }
  vueApp.activeMode = ToothNumberMode;
  ToothNumberMode.isActive = true;
  ToothNumberMode.isOldNumbers = isOldNumbers;

  //   vueApp.allItems.forEach((item) => {
  //     if (item.isVisible) viewer.set_opacity(item.id, item.isTooth ? 0.5 : 0);
  //   });

  await drawTeethNumbers();
}

function initToothNumberControls() {
  if (!controlsInitialized) {
    vueApp.$on("teethNamingChanged", (teethNaming) => {
      console.log("teethNaming numberMode", teethNaming);
      vueApp.allTeeth.forEach((tooth) => {
        redrawToothNumber(tooth, false);
      });
      // if (ToothNumberMode.isActive) {

      // }
    });

    var ctrls = [ToothNumberControls, ToothNumberButtons, ToothNumberDialog];
    ctrls.forEach((component, index) => {
      const componentInstance = new Vue({
        ...component,
        propsData: { mode: ToothNumberMode },
      });
      const vueContainer = document.createElement("div");
      let wrapper = document.getElementById("stl_wrapper");
      if (index > 1) {
        wrapper = document.getElementById("views_cont");
      }
      wrapper.appendChild(vueContainer);
      componentInstance.$mount(vueContainer);
    });

    vueApp.$on("colorChanged", (target) => {
      if (ToothNumberMode.isActive) {
        let item = vueApp.allItems.find((x) => x.id === target);
        if (item && item.isTooth) {
          console.log(`colorChanged handler`, item);
          redrawToothNumber(item);
        }
      }
    });

    vueApp.$on("visibilityChanged", (target) => {
      if (ToothNumberMode.isActive) {
        if (target && target.isTooth) {
          redrawToothNumber(target);
        } else {
          drawTeethNumbers();
        }
      }
    });

    controlsInitialized = true;
  }
}

async function initToothNumberOptions() {
  if (!numberFont) {
    numberFont = vueApp.defaultFont
      ? vueApp.defaultFont
      : await loadFont("fonts/helvetiker_regular.typeface.json");
    viewer.controls.addEventListener("change", onCameraChangeForNumbers);
  }

  if (!maxCenter || !mandCenter) {
    maxBox = getTeethBox(true);
    maxCenter = new THREE.Vector3(
      maxBox.center.x,
      maxBox.min.y + dy * 1.8,
      maxBox.min.z + dz * 2,
    );
    //   drawPoint(maxCenter, 0x0000ff);

    mandBox = getTeethBox(false);
    mandCenter = new THREE.Vector3(
      mandBox.center.x,
      mandBox.max.y - dy * 1.8,
      mandBox.min.z + dz * 2,
    );
    //   drawPoint(mandCenter, 0xffff00);
  }
}

function getTeethBox(isMaxilla) {
  var min = { x: 100000, y: 100000, z: 100000 };
  var max = { x: -10000, y: -100000, z: -100000 };
  var teethBox = { min, max };
  vueApp.allItems.forEach(function (model) {
    if (model.isTooth && (isMaxilla == null || model.isMaxilla == isMaxilla)) {
      var mesh = viewer.get_model_mesh(model.id);
      var geometry = mesh.geometry.clone();
      geometry.applyMatrix4(mesh.matrix);
      var toothBox = geometry.boundingBox;
      if (toothBox.min.x < teethBox.min.x) {
        teethBox.min.x = toothBox.min.x;
      }
      if (toothBox.min.y < teethBox.min.y) {
        teethBox.min.y = toothBox.min.y;
      }
      if (toothBox.min.z < teethBox.min.z) {
        teethBox.min.z = toothBox.min.z;
      }
      if (toothBox.max.x > teethBox.max.x) {
        teethBox.max.x = toothBox.max.x;
      }
      if (toothBox.max.y > teethBox.max.y) {
        teethBox.max.y = toothBox.max.y;
      }
      if (toothBox.max.z > teethBox.max.z) {
        teethBox.max.z = toothBox.max.z;
      }
    }
  });
  teethBox = offsetBox(teethBox, 0, 0, 0, 0);
  //   drawBox(teethBox);
  return teethBox;
}

function leaveToothNumberMode(saveChanges, saveActiveMode) {
  console.log("leaveToothNumberMode", saveChanges, saveActiveMode);
  removeTeethNumbers();

  vueApp.allItems.forEach(function (item) {
    if (item.isVisible) viewer.set_opacity(item.id, item.opacity); // item.isVisible &&
  });
  $(".tooth-number-mode-item").css("display", "none");
  //if (!saveActiveMode)
  vueApp.activeMode = null;
  ToothNumberMode.resetSelectedTooth();
  ToothNumberMode.isActive = false;
  vueApp.leaveModes(false, true);

  viewer.renderer.clippingPlanes =
    vueApp.savedData.clipData && vueApp.savedData.clipData.isEnabled
      ? globalPlanes
      : empty;

  if (ToothNumberMode.changedFiles.length > 0) {
    let uniqueFiles = [...new Set(ToothNumberMode.changedFiles)];
    if (saveChanges) {
      let numberChanges = getNumberChanges();
      if (numberChanges.length > 0) {
        updateToothNumbers(numberChanges);
      }
    } else {
      for (let filename of uniqueFiles) {
        let tooth = vueApp.getItemByFilename(filename);
        if (tooth) {
          tooth.newNumber = tooth.savedNumber;
          tooth.newNumberType = tooth.numberType ? tooth.numberType : "primary";
          tooth.newRemarks = tooth.remarks ? tooth.remarks : "";
          tooth.newPrevTag = tooth.prevTag ? tooth.prevTag : "";
        }
      }
    }

    for (let filename of uniqueFiles) {
      let tooth = vueApp.getItemByFilename(filename);
      if (tooth) {
        updateToothDentition(tooth, true);
        updateDisplayNumberAndName(tooth);
      }
    }
    ToothNumberMode.changedFiles = [];
  }
}

function getNumberChanges(resetChanges) {
  let uniqueFiles = [...new Set(ToothNumberMode.changedFiles)];
  let numberChanges = [];
  for (let [index, filename] of uniqueFiles.entries()) {
    let tooth = vueApp.getItemByFilename(filename);
    if (tooth) {
      let oldNumber = +tooth.savedNumber;
      let newNumber = tooth.newNumber ? +tooth.newNumber : +tooth.savedNumber;
      let oldNumberType = tooth.numberType ? tooth.numberType : "primary";
      let newNumberType = tooth.newNumberType ? tooth.newNumberType : "primary";
      let oldRemarks = tooth.remarks ? tooth.remarks : "";
      let newRemarks = tooth.newRemarks ? tooth.newRemarks : "";
      let oldPrevTag = tooth.prevTag ? tooth.prevTag : "";
      let newPrevTag = tooth.newPrevTag ? tooth.newPrevTag : "";
      let oldAddedTag = tooth.addedTag ? tooth.addedTag : null;
      let newAddedTag = tooth.newAddedTag ? tooth.newAddedTag : null;

      if (
        oldNumber !== newNumber ||
        oldNumberType !== newNumberType ||
        oldRemarks !== newRemarks ||
        oldPrevTag !== newPrevTag // || oldAddedTag !== newAddedTag
      ) {
        let change = {
          order: index,
          baseFileName: tooth.baseFileName,
          baseNumber: +tooth.number,
          // fileName: tooth.filename,
          oldNumber: oldNumber,
          newNumber: newNumber,
          oldNumberType: oldNumberType,
          newNumberType: newNumberType,
          oldRemarks: oldRemarks,
          newRemarks: newRemarks,
          oldPrevTag: oldPrevTag,
          newPrevTag: newPrevTag,
          oldAddedTag: oldAddedTag,
          newAddedTag: newAddedTag,
        };
        change.fileName = tooth.savedFileName; //getToothFileName(tooth);
        numberChanges.push(change);
      }

      // tooth.name = tooth.newNumber.toString();
      tooth.savedNumber = tooth.newNumber;
      tooth.numberType = tooth.newNumberType;
      tooth.remarks = tooth.newRemarks;
      tooth.prevTag = tooth.newPrevTag;
      if (tooth.newAddedTag) {
        tooth.addedTag = tooth.newAddedTag;
      }
      tooth.savedFileName = getToothFileName(tooth);
    }
  }
  if (resetChanges) {
    ToothNumberMode.changedFiles = [];
  }
  return numberChanges;
}

function getNumberChangesCount() {
  let retval = 0;

  if (ToothNumberMode && ToothNumberMode.changedFiles) {
    let uniqueFiles = [...new Set(ToothNumberMode.changedFiles)];
    for (let filename of uniqueFiles) {
      let tooth = vueApp.getItemByFilename(filename);
      if (tooth) {
        let oldNumber = +tooth.savedNumber;
        let newNumber = tooth.newNumber ? +tooth.newNumber : +tooth.savedNumber;
        let oldNumberType = tooth.numberType ? tooth.numberType : "primary";
        let newNumberType = tooth.newNumberType
          ? tooth.newNumberType
          : "primary";
        let oldRemarks = tooth.remarks ? tooth.remarks : "";
        let newRemarks = tooth.newRemarks ? tooth.newRemarks : "";
        let oldPrevTag = tooth.prevTag ? tooth.prevTag : "";
        let newPrevTag = tooth.newPrevTag ? tooth.newPrevTag : "";
        // let oldAddedTag = tooth.addedTag ? tooth.addedTag : null;
        // let newAddedTag = tooth.newAddedTag ? tooth.newAddedTag : null;

        if (
          oldNumber !== newNumber ||
          oldNumberType !== newNumberType ||
          oldRemarks !== newRemarks ||
          oldPrevTag !== newPrevTag // || oldAddedTag !== newAddedTag
        ) {
          retval++;
        }
      }
    }
  }

  return retval;
}

//#region Draw

async function drawTeethNumbers() {
  await initToothNumberOptions();
  vueApp.allTeeth
    .sort((a, b) => b.number - a.number)
    .forEach((tooth) => {
      let mesh = viewer.get_model_mesh(tooth.id);
      if (!mesh) return;
      if (!mesh.textPoint) {
        let center = tooth.isMaxilla ? maxCenter : mandCenter;
        let box = tooth.defaultBox;

        let x = box.center.x;
        let y = tooth.isMaxilla ? box.min.y + dy + 1.8 : box.max.y - dy * 1.8;
        let z = box.center.z;
        mesh.apexCenter = new THREE.Vector3(x, y, z);
        // drawPoint(tempCenter, 0x00ff00);
        let distance = calculateDistance(mesh.apexCenter, center);
        let coef = (distance + dz * 2) / distance;
        let px = (x - center.x) * coef + center.x;
        let py = (y - center.y) * coef + center.y;
        let pz = (z - center.z) * coef + center.z;
        mesh.textPoint = new THREE.Vector3(px, py, pz);
        // drawPoint(targetPomesh.textPoint int1, tooth.isMaxilla ? 0x0000ff : 0xffff00);
        // drawLine(textPoint, center);
        coef = (distance + dz) / distance;
        px = (x - center.x) * coef + center.x;
        py = (y - center.y) * coef + center.y;
        pz = (z - center.z) * coef + center.z;
        mesh.apexEdge = new THREE.Vector3(px, py, pz);
        // drawPoint(mesh.textLookPoint, tooth.isMaxilla ? 0x0000ff : 0xffff00);
      }

      redrawToothNumber(tooth, ToothNumberMode.isOldNumbers);
    });
  numbersVisible = true;
}

function redrawToothNumber(tooth, isOldNumbers) {
  console.log("redrawToothNumber", tooth);
  if (tooth) {
    updateDisplayNumberAndName(tooth);
    let mesh = viewer.get_model_mesh(tooth.id);
    if (!mesh || !mesh.geometry || !mesh.geometry.boundingBox) {
      return;
    }
    if (mesh.numberLabel) {
      mesh.numberLabel.style.display = "none";
    }
    if (tooth.isVisible && mesh.visible) {
      drawToothNumber(tooth, mesh, true);
      mesh.numberLabel.style.display = "block";
    }
  }
}

function removeTeethNumbers() {
  vueApp.allTeeth.forEach((item) => {
    let mesh = viewer.get_model_mesh(item.id);
    if (mesh.numberLabel) {
      mesh.numberLabel.style.display = "none";
    }
  });
  numbersVisible = false;
}

function onCameraChangeForNumbers(controls) {
  const currentTicks = Date.now();
  if (numbersVisible && currentTicks - lastTicks > 10) {
    lastTicks = currentTicks;
    vueApp.allTeeth.forEach((tooth) => {
      let mesh = viewer.get_model_mesh(tooth.id);
      if (mesh.numberLabel) {
        drawToothNumber(tooth, mesh);
      }
    });
  }
}

function drawToothNumber(tooth, mesh, updateText) {
  let canvasHalfWidth = viewer.renderer.domElement.offsetWidth / 2;
  let canvasHalfHeight = viewer.renderer.domElement.offsetHeight / 2;

  let objectCenter = mesh.textPoint;
  let centerPosition = new THREE.Vector3(
    objectCenter.x,
    objectCenter.y,
    objectCenter.z,
  );
  centerPosition = centerPosition.project(viewer.camera);
  centerPosition.x = centerPosition.x * canvasHalfWidth + canvasHalfWidth;
  centerPosition.y = -(centerPosition.y * canvasHalfHeight) + canvasHalfHeight;

  let numberLabel = mesh.numberLabel;
  if (!numberLabel) {
    numberLabel = mesh.numberLabel = document.createElement("div");
    numberLabel.style.color = `${tooth.color}`;
    numberLabel.style.border = `2px solid ${tooth.color}`;
    numberLabel.style.position = "absolute";
    // measureLabel.style.zIndex = "9999";
    numberLabel.style.width = "auto";
    numberLabel.style.height = "auto";
    numberLabel.style.padding = "2px";
    numberLabel.style.pointerEvents = "none";
    // measureLabel.style.opacity = "0.5";
    numberLabel.style.backgroundColor = "rgba(0, 0, 0, 0.7)";
    numberLabel.style.display = "none";
    numberLabel.style.maxWidth = "85px";
    numberLabel.style.minWidth = "32px";

    numberLabel.textContent = `${tooth.number}`;

    document.getElementById("stl_wrapper").appendChild(numberLabel);
  }

  numberLabel.style.display = mesh.visible ? "block" : "none";
  if (mesh.visible) {
    if (updateText) {
      numberLabel.textContent = `${tooth.displayNumber}`;
      numberLabel.style.color = `${tooth.color}`;
      numberLabel.style.border = `2px solid ${tooth.color}`;
    }
    numberLabel.style.left = `${centerPosition.x - 35}px`;
    numberLabel.style.top = `${centerPosition.y}px`;
  }
  return numberLabel;
}

//#endregion

export {
  ToothNumberMode,
  initToothNumberControls,
  enterToothNumberMode,
  leaveToothNumberMode,
  redrawToothNumber,
  showOldToothNumbers,
  drawTeethNumbers,
  removeTeethNumbers,
  getNumberChanges,
  getNumberChangesCount,
};
